import React from 'react';

import { Tab, Label, Alert } from './InboxTab.styles';

export const InboxTabComponent = ({ label, count = null, isSelected, hasAlert, onClick, CountBox, disabled }) => {
  return (
    <Tab onClick={onClick} isSelected={isSelected} disabled={disabled}>
      <Label disabled={disabled}>{label}</Label>
      {count !== null && (
        <span style={{ marginLeft: '4px', textAlign: 'center', position: 'relative' }}>
          <CountBox>{count}</CountBox>
        </span>
      )}
      {count !== null && hasAlert && <Alert disabled={disabled}>!</Alert>}
    </Tab>
  );
};
export default InboxTabComponent;
